var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccessibilityIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#929993",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 56.693
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 316.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8 281.8v100.5l-79.4 136.8M347.4 382.3l79.4 136.8M233.3 264.8l109.5 17 123.9-17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343 182.9v-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 85.039
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccessibilityIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "accessibility-icon.d3108d9880c927a71940e2a4c70f30c2.svg";